// Gỡ entry workspace non-dev (card #254) khỏi registry `~/.avatar/workspaces.json`.
//
// Chỉ `sync --all` gọi: chữa máy mà `status`/`doctor` của CLI cũ đã đăng ký nhầm workspace
// Avatar DataHub. Một chiều (chỉ BỚT entry), không có gì để gỡ ⇒ KHÔNG ghi file — cùng kỷ luật
// với `pruneMissingWorkspaces` nên gọi kể cả ở `--dry-run` vẫn an toàn.
import type { WorkspaceDecision } from "./plan-sync-all-across-registered-workspaces.js";
import {
  DEFAULT_REGISTRY_PATH,
  readWorkspaceRegistry,
  writeEntries,
} from "./workspace-registry-store.js";

/** Trả path đã gỡ (rỗng nếu không có workspace non-dev nào). */
export async function removeNonDevWorkspacesFromRegistry(
  decisions: readonly WorkspaceDecision[],
  registryPath: string = DEFAULT_REGISTRY_PATH,
): Promise<string[]> {
  const nonDev = new Set(
    decisions
      .filter((d) => d.kind === "skipped" && d.reason === "non-dev-workspace")
      .map((d) => d.path),
  );
  if (nonDev.size === 0) return [];
  const entries = await readWorkspaceRegistry(registryPath);
  const kept = entries.filter((e) => !nonDev.has(e.path));
  if (kept.length === entries.length) return [];
  await writeEntries(registryPath, kept);
  return entries.filter((e) => nonDev.has(e.path)).map((e) => e.path);
}
